import React from "react";
import { formatNumber } from "utils/currencyFormat"; 

const TableDanhSachTaiSanBan = ({ list, onEditItem, onDeleteItem }) => {
    
    const calculateTotal = (field) => {
        return list.reduce((sum, item) => sum + (item[field] || 0), 0);
    };

    const totalSoTien = calculateTotal("SoTien");
    const totalPhiKhac = calculateTotal("PhiKhac");
    const totalTongTien = totalSoTien + totalPhiKhac;

    return (
        <div className="Table-main-new">
            <div className="table-mobile table-mobile-hover">
                <div className="custom-table-wrapper">
                    <div className="table-headers" >
                        <div className="custom-table-header text-center" style={{ width: '5%' }}>
                            <p className="color-do-bold">[{list.length}]</p>
                        </div>
                        <div className="custom-table-header" style={{ width: '15%' }}>
                            <p>Loại tài sản</p>
                        </div>
                        <div className="custom-table-header" style={{ width: '20%' }}>
                            <p>Tên tài sản</p>
                        </div>
                        <div className="custom-table-header text-right" style={{ width: '15%' }}>
                            <p>Giá bán <br/> <span className="color-do-bold">{formatNumber(totalSoTien)}</span></p>
                        </div>
                        <div className="custom-table-header text-right" style={{ width: '15%' }}>
                            <p>Phí khác <br/> <span className="color-do-bold">{formatNumber(totalPhiKhac)}</span></p>
                        </div>
                        <div className="custom-table-header text-right" style={{ width: '20%' }}>
                            <p>Tổng tiền <br/> <span className="color-do-bold">{formatNumber(totalTongTien)}</span></p>
                        </div>
                        <div className="custom-table-header text-center" style={{ width: '10%' }}>
                            <p>Thao tác</p>
                        </div>
                    </div>
                    <div className="custom-table-body">
                        {list.length === 0 ? (
                            <div className="custom-table-row">
                                <div className="custom-table-cell text-center" style={{ width: "100%" }}>
                                    Chưa có tài sản nào trong đơn hàng.
                                </div>
                            </div>
                        ) : (
                            list.map((item, index) => (
                                <div className="custom-table-row" key={item.localId || index}>
                                    <div className="custom-table-cell text-center" style={{ width: '5%', justifyContent: 'center' }}>
                                        <span className="mobile-column-name">STT</span>
                                        {index + 1}
                                    </div>
                                    <div className="custom-table-cell" style={{ width: '15%' }}>
                                        <span className="mobile-column-name">Loại tài sản</span>
                                        {item.LoaiTaiSanTen}
                                    </div>
                                    <div className="custom-table-cell" style={{ width: '20%' }}>
                                        <span className="mobile-column-name">Tên tài sản</span>
                                        {item.TenTaiSan}
                                    </div>
                                    <div className="custom-table-cell text-right" style={{ width: '15%',justifyContent: 'flex-end' }}>
                                        <span className="mobile-column-name">Giá bán</span>
                                        {formatNumber(item.SoTien)}
                                    </div>
                                    <div className="custom-table-cell text-right" style={{ width: '15%', justifyContent: 'flex-end' }}>
                                        <span className="mobile-column-name">Phí khác</span>
                                        {formatNumber(item.PhiKhac)}
                                    </div>
                                    <div className="custom-table-cell text-right" style={{ width: '20%', justifyContent: 'flex-end' }}>
                                        <span className="mobile-column-name">Tổng tiền</span>
                                        {formatNumber(item.SoTien + item.PhiKhac)}
                                    </div>
                                    <div className="custom-table-cell text-center" style={{ width: '10%', justifyContent: 'center'}}>
                                        <span className="mobile-column-name">Thao tác</span>
                                        <a
                                            className="iconTableMorman"
                                            title="Sửa tài sản này"
                                            onClick={() => onEditItem(item)} 
                                        >
                                            <img src="/app-assets/images/icon-button-edit-v2.png" alt="Sửa" style={{width: 16}} />
                                        </a>
                                        &nbsp;                                       
                                        <a
                                            className="iconTableMorman"
                                            title="Xóa tài sản này"
                                            onClick={() => onDeleteItem(item)}
                                        >
                                            <img src="/app-assets/images/icon-xoa-v2.png" alt="Xóa" style={{width: 16}} />
                                        </a>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TableDanhSachTaiSanBan;